import { BlogCard } from '../../home/BlogGrid/BlogGrid';
import styles from './RelatedArticle.module.scss';
import { Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { getObjFrmArray } from '../../../../../commons/utils/utils';

const RelatedArticle = ({ data, categoryList, relatedBlogs }) => {
  const router = useRouter();
  const currentPathname = router.pathname.split('/')[1];

  const relatedPost = relatedBlogs?.filter(function (obj) {
    return obj.id !== data.id;
  });

  const handleCategory = (id) => {
    if (id) {
      router.push(
        `/${currentPathname}/${getObjFrmArray(categoryList, 'id', id).slug}`,
        undefined,
        {
          shallow: true,
        }
      );
    } else {
      router.push(`${currentPathname}`);
    }
  };

  const handelRead = (item) => {
    const categoryId = item.category_collection[0];
    router.push(
      `/${currentPathname}/${
        getObjFrmArray(categoryList, 'id', categoryId.term_id).slug
      }/${item.slug}`,
      undefined,
      {
        shallow: true,
      }
    );
  };

  const isOdd = (num) => {
    if (num % 2 == 1) {
      return true;
    }
    return false;
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.divider}></div>
        <Typography
          variant="h2"
          color="primary.main"
          className={styles.relatedArticleTitle}
        >
          Explore Related Articles
        </Typography>
        <div className={styles.blogContainer}>
          <div className={styles.blogItemWrapper}>
            {relatedPost.slice(0, 4)?.map((item, i) => {
              return (
                item.id != data.id && (
                  <BlogCard
                    key={i}
                    size={isOdd(i) ? 'medium' : 'small'}
                    item={item}
                    categoryCB={handleCategory}
                    readCB={handelRead}
                    currentPathname={currentPathname}
                    className={styles.relatedSingleBlog}
                  />
                )
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default RelatedArticle;
